


















































































































































































































































































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator'
import Loading from './components/Loading.vue';
import {checkLogin, CredentialLogin, loginServer, logout} from "./plugins/utils/loginUtils";
import {pad} from "@/plugins/utils/utils";

@Component({
  components: {
    Loading
  }
})
export default class App extends Vue {
  @Watch('$route', { immediate: true, deep: true })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onUrlChange() {
    /* console.log(newVal); */
    window.scrollTo(0,0);
  }

  get loading(): boolean {
    return this.$store.getters.loadingFlag;
  }

  get error(): {flag: boolean; text: string; status: string} {
    return this.$store.getters.error;
  }

  get checkToken(): boolean {
    const token = this.$store.getters.token;
    if(token) return true;
    else return false;
  }

  get userNome(): string {
    if(this.$store.getters.userData && this.$store.getters.userData.nome){
      return this.$store.getters.userData.nome;
    }
    else {
      return "";
    }
  }
  menu1 = false;
  menu2 = false;
  globalDate = new Date();
  get clock(): string {
    return pad(this.globalDate.getHours().toString(),2)+":"+pad(this.globalDate.getMinutes().toString(),2);
  }
  get date(): string {
    return pad(this.globalDate.getDate().toString(),2)+"/"+pad(this.globalDate.getMonth()+1,2)+"/"+pad(this.globalDate.getFullYear().toString(),4);
  }
  get dateCalendar(): string {
    return pad(this.globalDate.getFullYear().toString(),4)+"-"+pad(this.globalDate.getMonth()+1,2)+"-"+pad(this.globalDate.getDate().toString(),2);
  }

  get version(): string{
    return this.$store.getters.version;
  }
  primaryColor = this.$vuetify.theme.themes.light.primary;
  secondaryColor = this.$vuetify.theme.themes.light.secondary;
  helpeGrey = this.$vuetify.theme.themes.light.helpeGrey;

  created(){
    this.$store.dispatch("init", () => {
      checkLogin((value: CredentialLogin | null) => {
        if(value){
          loginServer(
            value.username,
            value.password,
            () => {
              if(this.$route.name == "Login"){
                this.$router.push("/dashboard");
              }
              this.$store.commit("setLoading",false);
            },
            () => {
              logout(true);
            }
          );
        }
        else{
          logout(false);
        }        
      });
    });

    setInterval(() => {
      this.globalDate = new Date();
    }, 1000*20);

  }

  drawer = false;

  logoutAction(): void{
    logout(true);
  }
}
